import DataConsentTrainerService from "@/services/DataConsentTrainerService";
import SearchService from "@/services/SearchService";
import router from "@/router";

const getDefaultState = () => ({
    dataConsentTrainerCount:[],
    dataConsentAll:[]
})

const dataConsentTrainer = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
      setDataConsentTrainerCount(state,val){
        state.dataConsentTrainerCount = val;
      },
      setDataConsentAll(state,val){
        state.dataConsentAll = val;
      }
    },
    actions: {
        TEST_ACTION(){
          console.log("test action")
        },
        async ADD_DATACONSENT(context){
          
              var res = await DataConsentTrainerService.fetchDataConsentTrainer();
              
              context.commit("setDataConsentTrainerCount",res.data.result);
        },
        async ADD_TRAINERDATA(context){
            var res = await DataConsentTrainerService.fetchAllTrainerData();
            
            context.commit("setDataConsentAll",res.data.result);
      },
    },
    getters: {
        getDataConsentTrainerCount: (state)=> state.dataConsentTrainerCount,
        getTrainerData: (state)=> state.dataConsentAll,
    }
}

export default dataConsentTrainer;